export default __webpack_public_path__ + "static/media/Giselle 9781408333778.22a5a8e9.jpg";